









































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LoggedIn extends Vue {
  
  // lifecycle mounted
  mounted() {
    var $ = (window as any).jQuery || {};
    $('[data-pages="sidebar"]').each(function(_:number, instance:any) {
      var $element = $(instance as any)
      $element.sidebar($element.data())
    });
  }
}
